import { Link } from "react-router-dom";
import type { Episode } from "@/types/episode";

interface ChapterRailProps {
  episodes: Episode[];
}

export default function ChapterRail({ episodes }: ChapterRailProps) {
  return (
    <div className="-mx-4 md:mx-0 px-4 md:px-0 overflow-x-auto hide-scrollbar">
      <div className="flex md:grid md:grid-cols-4 lg:grid-cols-6 gap-3 min-w-max md:min-w-0 pb-1">
        {episodes.map((episode, index) => (
          <Link
            key={episode.id}
            to={`/detail/${episode.id}`}
            className="group w-[104px] md:w-auto shrink-0 rounded-md overflow-hidden bg-background-100 border border-background-200/70 hover:border-accent-500/60 transition-colors cursor-pointer anim-fade-up"
            style={{ animationDelay: `${index * 40}ms` }}
          >
            <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-900">
              <img
                src={episode.cover}
                alt={episode.title}
                title={`${episode.title} 观看入口`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 to-transparent" />
              <span className="absolute bottom-1.5 left-2 font-label text-[11px] tracking-wider text-accent-500">
                EP {String(episode.number).padStart(2, "0")}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}